import React from "react";
import ContactUs from "../pages/ContactUs/ContactUs.jsx";
import Home from "../pages/Home/Home.jsx";
import Path from "./Constant/RoutePath.jsx";
import ArchitectingNext from "../pages/ArchitectingNext/ArchitectingNext.jsx";
import OurCertificate from "../pages/Home/HomeComponets/OurCertificate/OurCertificate.jsx";
import B2B from "../pages/B2B/B2B.jsx";
export default function PAGES() {
  return {
    PUBLIC_PAGES: [
      { path: Path.HOME, element: <Home /> },
      { path: Path.CAMPAIGN, element: <Home isCampaign /> },
      { path: Path.CONTACTUS, element: <ContactUs /> },
      { path: Path.ARCHITECTING, element: <ArchitectingNext /> },
      { path: Path.CERTIFICATES, element: <OurCertificate /> },
      { path: Path.B2B, element: <B2B /> },
    ],
  };
}
